import { render, staticRenderFns } from "./PublishInformationModal.vue?vue&type=template&id=406305f3"
import script from "./PublishInformationModal.vue?vue&type=script&lang=js"
export * from "./PublishInformationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports